// @flow
//eslint-disable-next-line
import React, { useState, useEffect } from 'react'

import { isMobile } from 'react-device-detect'

import { useDispatch, useSelector } from 'react-redux'
import queryString from 'query-string'

import {
	APP_HELPER,
	ARRAY_ROUTE_CONSTANTS,
	ROUTE_CONSTANTS,
	HELPER,
	HISTORY,
	PRODUCT_HELPER,
} from '../../../utils'
import { alertActions, cartActions, configActions, metaAction } from '../../../store/actions'
import { MetaTags, Alert } from '../../../components'
import { usePageViews, useTranslation, useToaster } from '../../../hooks'

let pathname, catalog_url, params, timeoutTime

function AppParentWrapper() {
	let { addToast } = useToaster()
	let translate = useTranslation()
	let dispatch = useDispatch()
	const { toast, config, meta, inventory } = useSelector((state) => state)
	const { visibleProducts } = inventory
	const { showProductDetail, buyNowClicked } = useSelector((state) => state.action)
	const { toaster, translation } = meta
	const { catalog_cart_items } = useSelector((state) => state.config.catalog_journey_settings)
	const {
		catalogue_key,
		custom_catalog,
		catalog_info_loading,
		catalog_journey_settings,
		config_info_loaded,
		config_info_loading,
		disableCatalogInfoLoading,
	} = config
	const { location } = HISTORY
	const { locale } = useSelector((state) => state.Intl)
	const { cart_items, item_added } = useSelector((state) => state.cart)
	const toastStatus = toaster.status
	const translationStatus = translation.status

	const [added, setAdded] = useState(false)

	//componentDidMount
	useEffect(() => {
		/*
          CLEAR ALERTS
        */
		dispatch(alertActions.clear())
		/*
          SAVE ACTION CREATERS FOR HELPER USAGE
        */
		if (HELPER.isEmpty(toaster.addToast) && toastStatus !== 1) {
			dispatch(metaAction.SAVE_TOAST(addToast))
		}
		if (HELPER.isEmpty(translation.translate) && translationStatus !== 1) {
			dispatch(metaAction.SAVE_TRANSLATION(translate))
		}
		/*
          LOAD STORE CONFIGURATION
        */
		// Fetch catalog url from url
		pathname = location.pathname
		// Remove backslash from route name
		catalog_url = pathname.slice(1)
		// Fetch product params from url : if any
		params = queryString.parse(location.search)
		if (
			pathname === ROUTE_CONSTANTS.BASE &&
			HELPER.isEmpty(catalog_url) &&
			HELPER.isEmpty(catalogue_key)
		) {
			APP_HELPER.MOVE_TO_VIEW_ALL_STORES()
		} else if (!ARRAY_ROUTE_CONSTANTS.includes(pathname)) {
			if (!HELPER.isEmpty(catalog_url)) {
				if (!config_info_loading) {
					/*
                      LOADING STORE CONFIGURATION
                    */
					;(catalogue_key !== pathname.split('/')[1] || visibleProducts.length === 0) &&
						callStoreConfiguration(catalog_url, false)
				}
			} else if (HELPER.isEmpty(catalog_url)) {
				/*
                  NO STORE CONFIGURATION FOUND - REDIRECT TO BSECURE.PK WEBSITE FOR PROMOTION PURPOSES
                */
				HELPER.REDIRECT_TO_PATH(process.env.REACT_APP_BSECURE_FEATURE_URL)
			}
		}

		// returned function will be called on component unmount
		return () => {}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		if (
			!HELPER.isEmpty(catalogue_key) &&
			!config_info_loading &&
			config_info_loaded &&
			!ARRAY_ROUTE_CONSTANTS.includes(catalogue_key)
		) {
			/*
            LOADING STORE CONFIGURATION
            */
			if (pathname === ROUTE_CONSTANTS.BASE && custom_catalog) {
				//   CUSTOM CATALOG : LOADING STORE CONFIGURATION
				callStoreConfiguration(catalogue_key, true)
			} else {
				callStoreConfiguration(HELPER.isEmpty(catalogue_key) ? catalog_url : catalogue_key, false)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [catalogue_key])

	useEffect(() => {
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toast])

	useEffect(() => {
		if (config_info_loaded) {
			callCatalogInfo()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [config_info_loaded])

	useEffect(() => {
		if (!isMobile) {
			var body = document.body
			body.classList.remove('overflowHidden')
			if (showProductDetail) {
				body.classList.add('overflowHidden')
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showProductDetail])

	useEffect(() => {
		/*
          UPDATE APPLICATION LOCALE - AND REDEFINE THEME PROVIDER WITH UPDATED LANG DIRECTION
        AFTER UPDATE APPLICATION LOCALE - ALSO UPDATE CART ITEMS NAME
        */
		if (
			!catalog_info_loading &&
			!HELPER.isEmpty(catalog_cart_items) &&
			!HELPER.isEmpty(catalogue_key) &&
			!HELPER.isEmpty(cart_items.items)
		) {
			dispatch(
				cartActions.UPDATE_CART_LOCALE({
					...cart_items,
					updated_cart_items: PRODUCT_HELPER.UPDATE_CART_LANG(cart_items),
				})
			)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [catalog_info_loading, locale])

	useEffect(() => {
		if (
			!HELPER.isEmpty(item_added?.item) &&
			!catalog_info_loading &&
			!disableCatalogInfoLoading &&
			!buyNowClicked
		) {
			dispatch(cartActions.UPDATE_CART())
			if (!showProductDetail) {
				dispatch(cartActions.REMOVE_CART_ITEMS_FROM_CART(item_added?.item))
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [item_added?.item, catalog_info_loading, disableCatalogInfoLoading])

	const callStoreConfiguration = (catalogue_key, state_custom_catalog) => {
		const product_id = !HELPER.isEmpty(queryString.parse(location.search)?.product_id)
			? queryString.parse(location.search)?.product_id
			: ''
		dispatch(
			configActions.STORE_CONFIGURATION(catalogue_key, product_id, HISTORY, state_custom_catalog)
		)
		// Remove product params from url : after configuration api is called once.
		if (!HELPER.isEmpty(params?.product_id)) {
			const queryParams = new URLSearchParams(location.search)
			queryParams.delete('product_id')
		}
	}

	const callCatalogInfo = () => {
		if (
			(!HELPER.isEmpty(catalogue_key) || !HELPER.isEmpty(catalog_url)) &&
			!catalog_info_loading &&
			!disableCatalogInfoLoading
		) {
			dispatch(metaAction.SAVE_TRANSLATION(translate))
		}
	}

	useEffect(() => {
		//not call catalog if under contruction
		if (
			// eslint-disable-next-line no-prototype-builtins
			config.merchant.hasOwnProperty('under_construction') &&
			config?.merchant?.under_construction === 0
		) {
			dispatch(configActions.CATALOG_CONFIGURATION(HISTORY))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [config.merchant?.under_construction])

	useEffect(() => {
		/*
          UPDATE CART ITEMS
        */
		if (
			!HELPER.isEmpty(catalog_cart_items) &&
			!HELPER.isEmpty(catalog_cart_items?.id) &&
			!catalog_info_loading &&
			!disableCatalogInfoLoading
		) {
			if (!added) {
				setAdded(true)
				//ADD CATALOG PRODUCT IN CART
				timeoutTime = setTimeout(() => {
					if (!HELPER.isEmpty(catalog_cart_items?.id)) {
						clearTimeout(timeoutTime)
						dispatch(cartActions.REMOVE_CART_ITEMS_FROM_CATALOG_JOURNEY_SETTINGS())
					}
				}, 2000)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [catalog_journey_settings?.catalog_cart_items])

	return (
		<>
			<Alert />
			{usePageViews()}
			<MetaTags />
		</>
	)
}

export default AppParentWrapper
